import React from 'react'

import { ArchiveJobsModal } from 'components/modals/ArchiveJobsModal/ArchiveJobsModal'
import { DeleteJobsModal } from 'components/modals/DeleteJobsModal/DeleteJobsModal'
import { ExportJobsModal } from 'components/modals/ExportJobsModal/ExportJobsModal'
import { PositionManagementModal } from 'components/modals/PositionManagementModal/PositionManagementModal'
import { PositionSelectionModal } from 'components/modals/PositionSelectionModal/PositionSelectionModal'
import { PositionTemplateModal } from 'components/modals/PositionTemplateModal/PositionTemplateModal'
import { SavePositionTemplateModal } from 'components/modals/SavePositionTemplateModal/SavePositionTemplateModal'
import { TemplateBasedJobPositionModal } from 'components/modals/TemplateBasedJobPositionModal/TemplateBasedJobPositionModal'
import { Pane } from 'components/shared/Pane/Pane'
import { JobsTable } from './common/JobsTable/JobsTable'
import { JobsHeader } from './JobsHeader'
import { useProjects } from './hooks'

import styles from './JobsListing.module.scss'

export const JobsListing = () => {
  const { state, handlers } = useProjects()

  const {
    actions,
    activeTemplate,
    project,
    search,
    filter,
    departmentValue,
    hasAnyTemplates,
    isCreatePositionModalOpen,
    isCreateTemplateModalOpen,
    isDeleteJobsModalOpen,
    isArchiveJobsModalOpen,
    isExportJobsModalOpen,
    isPositionTemplateModalOpen,
    isSaveTemplateModalOpen,
    isSelectionModalOpen,
  } = state
  const {
    handleCreatePositionOpen,
    handleCreateTemplateOpen,
    handleCreatePositionModalBack,
    handleCreatePositionModalClose,
    handleCreatePositionModalConfirm,
    handleCreateTemplateModalBack,
    handleCreateTemplateModalClose,
    handleCreateTemplateModalConfirm,
    handleDeleteJobsModalClose,
    handleDeleteJobsModalConfirm,
    handleArchiveJobsModalClose,
    handleArchiveJobsModalConfirm,
    handleExportJobsModalClose,
    handlePositionTemplateModalBack,
    handlePositionTemplateModalClose,
    handlePositionTemplateModalConfirm,
    handleSaveTemplateModalClose,
    handleSaveTemplateModalConfirm,
    handleSelectionModalClose,
    handleSelectionModalOpen,
    setActiveTemplate,
    setDepartment,
    setSearch,
    resetFilter,
    setFilter,
  } = handlers

  return (
    <>
      <Pane className={styles.jobs} tagName="article">
        <JobsHeader
          search={search}
          onSearchChange={setSearch}
          filter={filter}
          onFilterChange={setFilter}
          departmentValue={departmentValue}
          onDepartmentChange={setDepartment}
          actions={actions}
          hasAnyTemplates={hasAnyTemplates}
          onAddJobFromTemplate={handleSelectionModalOpen}
          onAddJobFromScratch={handleCreatePositionOpen}
        />
        <JobsTable {...{ search, filter, resetFilter }} />
      </Pane>
      {hasAnyTemplates ? (
        <PositionSelectionModal
          onClose={handleSelectionModalClose}
          onCreateTemplate={handleCreateTemplateOpen}
          onFromScratch={handleCreatePositionOpen}
          isOpen={isSelectionModalOpen}
        />
      ) : null}
      <PositionTemplateModal
        onBack={handlePositionTemplateModalBack}
        onCancel={handlePositionTemplateModalClose}
        onClose={handlePositionTemplateModalClose}
        onConfirm={handlePositionTemplateModalConfirm}
        isOpen={isPositionTemplateModalOpen}
        activeTemplate={activeTemplate}
        setActiveTemplate={setActiveTemplate}
      />
      <TemplateBasedJobPositionModal
        template={activeTemplate}
        onBack={handleCreateTemplateModalBack}
        onCancel={handleCreateTemplateModalClose}
        onClose={handleCreateTemplateModalClose}
        onConfirm={handleCreateTemplateModalConfirm}
        isOpen={isCreateTemplateModalOpen}
      />
      {isCreatePositionModalOpen ? (
        <PositionManagementModal
          onBack={handleCreatePositionModalBack}
          onCancel={handleCreatePositionModalClose}
          onClose={handleCreatePositionModalClose}
          onConfirm={handleCreatePositionModalConfirm}
          isOpen={isCreatePositionModalOpen}
          isStandalone={!hasAnyTemplates}
        />
      ) : null}
      <SavePositionTemplateModal
        onCancel={handleSaveTemplateModalClose}
        onClose={handleSaveTemplateModalClose}
        onConfirm={handleSaveTemplateModalConfirm}
        isOpen={isSaveTemplateModalOpen}
        project={project}
      />
      <ExportJobsModal
        onCancel={handleExportJobsModalClose}
        onClose={handleExportJobsModalClose}
        isOpen={isExportJobsModalOpen}
      />
      <DeleteJobsModal
        onCancel={handleDeleteJobsModalClose}
        onClose={handleDeleteJobsModalClose}
        onConfirm={handleDeleteJobsModalConfirm}
        isOpen={isDeleteJobsModalOpen}
      />
      <ArchiveJobsModal
        onCancel={handleArchiveJobsModalClose}
        onClose={handleArchiveJobsModalClose}
        onConfirm={handleArchiveJobsModalConfirm}
        isOpen={isArchiveJobsModalOpen}
        archived={filter.archived}
      />
    </>
  )
}
